module.exports = __webpack_public_path__ + "media/waiting-room-3.8e1d2341.mp4";